<div
  *ngrxLet="customFacade.customTransportScenarioList$ as transportScenarioList"
  class="modal-content"
  piqetAngularDraggable
>
  <ng-container
    *ngrxLet="customFacade.customMultipleTransportScenarioList$ as multipleTransportScenarioList"
  >
    <ng-container
      *ngrxLet="customFacade.replicateTransportScenarioList$ as replicateTransportScenarioList"
    >
      <div class="modal-header">
        <h2 class="modal-title ml-auto pl-5" id="exampleModalLabel">
          <div class="bootstrap-dialog-title" id="dialogMaterialCreate_title">
            {{ modalLabel }}
          </div>
        </h2>
        <button type="button" class="closeModal pull-right" aria-label="Close" (click)="onClose()">
          <img src="./assets/icons/pop-up-cross.svg" width="16" height="17" />
        </button>
      </div>

      <div class="modal-body body-modal" [ngClass]="{ 'disabled-popup': !checkEntireAccess }">
        <form id="frmProjectCreate" [formGroup]="customTransportScenarioForm">
          <div id="ProjectCreateValidationSummary" class="field-validation-error"></div>
          <div class="row">
            <div class="col-sm-12">
              <div class="custom-margin-transport required">
                <piqet-angular-common-input
                  formControlName="transportScenarioName"
                  [control]="customTransportScenarioForm.get('transportScenarioName')"
                  label="Transport scenario name"
                  placeholder="Transport scenario name"
                  [maxLength]="50"
                  [submitted]="submitted"
                  [errorMessages]="{
                    required: 'Transport scenario name is required',
                    whitespace: 'Transport scenario name is required'
                  }"
                >
                </piqet-angular-common-input>
              </div>
            </div>
          </div>
          <div class="row">
            <div
              class="col-sm-4 form-group checkbox-text checkBoxAlienMent"
              [ngClass]="{ disabled: modalLabel.toLowerCase() == 'review custom transport chain' }"
            >
              <input
                type="checkbox"
                class="chkOverview"
                [ngModelOptions]="{ standalone: true }"
                [(ngModel)]="enableMultipleSites"
                (change)="isChecked($event)"
              /><span> Transport to/from multiple sites</span>
            </div>
          </div>
          <div class="row" *ngIf="isHideDropDown">
            <div class="col-sm-6">
              <div class="form-group">
                <label class="sub-header-drpdown pb-2">Organization</label>
                <ng-select
                  [clearable]="true"
                  [clearOnBackspace]="false"
                  #material
                  [items]="organizationlist"
                  [searchable]="false"
                  bindLabel="name"
                  formControlName="organizationName"
                  [searchFn]="commonInputSearch"
                  [readonly]="isDisabledDropDown"
                  placeholder="Organization"
                  [(ngModel)]="setOrganizationValue"
                  (change)="selectValue($event)"
                >
                  <ng-template ng-header-tmp>
                    <div class="has-feedback">
                      <input
                        type="text"
                        (input)="material.filter($any($event.target).value)"
                        class="accordion-search form-control search-input"
                        id="inputValidation"
                        placeholder="Search..."
                      />
                      <span class="form-control-feedback">
                        <i class="fa fa-search icon"></i>
                      </span>
                    </div>
                  </ng-template>
                  <ng-template ng-option-tmp let-item="item" let-search="searchTerm">
                    <div [ngOptionHighlight]="search" title="{{ item?.name }}">{{ item.name }}</div>
                  </ng-template>
                </ng-select>
                <div
                  *ngIf="
                    (customTransportScenarioForm.controls['organizationName']?.touched &&
                      customTransportScenarioForm.controls['organizationName']?.invalid) ||
                    customTransportScenarioForm.controls['organizationName'].value?.name ===
                      'Organization' ||
                    (submitted &&
                      !customTransportScenarioForm.controls['organizationName'].value?.name)
                  "
                  class="input-error"
                >
                  Organization is required.
                </div>
              </div>
            </div>
          </div>
          <div class="row">
            <div class="col-sm-5 mt-2 form-group checkbox-text checkBoxAlienMent">
              <input type="checkbox" class="chkOverview" (change)="showPorts($event)" />
              <span> Show only ports</span>
            </div>
            <div class="col-sm-6" *ngIf="transportScenarioList.length && !enableMultipleSites">
              <div class="row">
                <div class="col-sm-3 checkbox-text form-group mt-2 checkBoxAlienMent">
                  <input
                    type="checkbox"
                    class="chkOverview"
                    (change)="isTruckChecked($event)"
                  /><span>Custom truck</span>
                </div>
                <div *ngIf="truckChecked" class="col-sm-4 form-group addcustomalign mt-2">
                  <a class="add-link" target="_blank" routerLink="custom/customTrucks"
                    ><span class="redirectLinkText">Add custom truck</span></a
                  >
                  <a
                    class="setLinkIconPosition"
                    target="_blank"
                    replaceUrl="true"
                    routerLink="custom/customTrucks"
                  >
                    <img src="./assets/icons/redirect-icon.svg" alt="" width="17" height="15" />
                  </a>
                  <span class="setLinkIconPosition" (click)="refreshTruckList()"
                    ><img src="./assets/icons/refresh-circle.svg" alt="" width="16" height="15"
                  /></span>
                </div>
              </div>
            </div>
          </div>

          <div class="row" *ngIf="!enableMultipleSites && !transportScenarioList.length">
            <div class="col-6">
              <div class="d-flex justify-content-end align-items-end">
                <p class="highlights" placeholder="Origin">
                  Select locations with "(Port)" for shipping
                </p>
              </div>
            </div>
          </div>
          <div *ngIf="!enableMultipleSites && !transportScenarioList.length" class="row">
            <div class="col-sm-6" style="box-shadow: none !important">
              <div class="form-group required" aria-required="true">
                <div class="ng-autocomplete-upper-class" style="box-shadow: none !important">
                  <ng-autocomplete
                    #auto
                    [data]="selectedCities"
                    [searchKeyword]="keyword"
                    (inputChanged)="onChangeSearch($event)"
                    historyIdentifier="selectedCities"
                    (selected)="selectEvent($event)"
                    (inputCleared)="onClearSearch($event)"
                    [itemTemplate]="itemTemplate"
                    [notFoundTemplate]="notFoundTemplate"
                    formControlName="origin"
                    [isLoading]="isLoading"
                    placeholder="Origin *"
                    [(ngModel)]="keywordAuto"
                    (keydown)="onKeyDownEvent($event)"
                    (scrolledToEnd)="onScroll()"
                  >
                  </ng-autocomplete>
                  <ng-template #itemTemplate let-item>
                    <div class="item"><span [innerHTML]="item.name"></span> &nbsp;</div>
                  </ng-template>

                  <ng-template #notFoundTemplate let-notFound>
                    <div [innerHTML]="notFound"></div>
                  </ng-template>
                </div>
              </div>
              <div
                *ngIf="setOriginsubmitted && customTransportScenarioForm.controls['origin'].errors"
              >
                <div
                  *ngIf="customTransportScenarioForm.controls['origin'].errors?.['required']"
                  class="input-error pedding2"
                >
                  Origin is required.
                </div>
              </div>
            </div>
            <div class="col-sm-1 aligniconQuestion">
              <span
                placement="auto"
                tooltipClass="sku-tooltip"
                ngbTooltip="Hint: For automatic calculation of sea distance the origin and destination should be the cities with (Port)"
              >
                <a class="info-icon">
                  <span>
                    <img src="./assets/icons/grey-question-icon.svg" width="16" height="16"
                  /></span>
                </a>
              </span>
            </div>
            <div class="col-sm-5 buttonrights">
              <button class="modelBtn setOriginBtn" (click)="setOrigin()">Set origin</button>
            </div>
          </div>
          <div *ngIf="!enableMultipleSites" class="row">
            <div class="input-error mt-2" *ngrxLet="customFacade.transportErrorMsg$ as error">
              <ul>
                <li
                  *ngIf="
                    !this.customTransportScenarioForm.controls['transportMode'].value &&
                    setDestinationsubmitted
                  "
                >
                  Please select transport mode
                </li>
                <li
                  *ngIf="customTransportScenarioForm.controls['distance'].errors?.['required']  && setDestinationsubmitted"
                >
                  Please enter distance
                </li>
                <li
                  *ngIf="
                    customTransportScenarioForm.controls['distance'].value === 0 &&
                    setDestinationsubmitted
                  "
                >
                  Must enter distance greater than 0
                </li>
                <li *ngIf="error">
                  {{ error }}
                </li>
                <li
                  *ngIf="
                    setDestinationsubmitted &&
                    customTransportScenarioForm.controls['destination'].errors
                  "
                >
                  <div
                    *ngIf="customTransportScenarioForm.controls['destination'].errors?.['required']"
                    class="input-error"
                  >
                    Destination is required.
                  </div>
                </li>
                <ng-container
                  *ngrxLet="customFacade.distanceErrorProjectCustom$ as distanceErrorProject"
                >
                  <li *ngIf="distanceErrorProject != ''">
                    <div class="mt-3">
                      <span class="input-error-distance">{{ distanceErrorProject }}</span>
                    </div>
                  </li>
                </ng-container>
              </ul>
            </div>
          </div>

          <div
            *ngIf="transportScenarioList.length && !enableMultipleSites"
            class="row"
            style="display: flex; align-items: flex-end"
          >
            <div class="col-sm-6 mb-1 d-flex">
              <div class="withtootips col-sm-11">
                <div class="form-group required" aria-required="true">
                  <label
                    *ngIf="customTransportScenarioForm.get('transportMode')?.value"
                    class="placeholder-sub-header pb-2"
                    >Holder_text</label
                  >
                  <div class="d-flex justify-content-end align-items-end">
                    <p class="highlights" placeholder="Origin">
                      Select locations with "(Port)" for shipping
                    </p>
                  </div>
                  <label class="placeholder-sub-header">Holder_text</label>
                  <div class="ng-autocomplete-upper-class" style="box-shadow: none !important">
                    <ng-autocomplete
                      #auto
                      [data]="selectedCities"
                      [searchKeyword]="keyword"
                      (inputChanged)="onChangeSearch($event)"
                      historyIdentifier="selectedCities"
                      (selected)="selectEvent($event)"
                      [isLoading]="isLoading"
                      (inputCleared)="onClearSearch($event)"
                      [itemTemplate]="itemTemplate"
                      [notFoundTemplate]="notFoundTemplate"
                      formControlName="destination"
                      placeholder="Destination"
                      (scrolledToEnd)="onScroll()"
                      [(ngModel)]="keywordAuto"
                      (keydown)="onKeyDownEvent($event)"
                    >
                    </ng-autocomplete>

                    <ng-template #itemTemplate let-item>
                      <div class="item"><span [innerHTML]="item.name"></span> &nbsp;</div>
                    </ng-template>

                    <ng-template #notFoundTemplate let-notFound>
                      <div [innerHTML]="notFound"></div>
                    </ng-template>
                  </div>
                </div>
              </div>
              <div
                class="align-self-center automatictooltip"
                [ngClass]="
                  customTransportScenarioForm.get('transportMode')?.value ? 'icon-top' : ''
                "
              >
                <span
                  placement="auto"
                  tooltipClass="sku-tooltip"
                  ngbTooltip="Hint: For automatic calculation of sea distance the origin and destination should be the cities with (Port)"
                >
                  <a class="info-icon">
                    <span>
                      <img src="./assets/icons/grey-question-icon.svg" width="16" height="16"
                    /></span>
                  </a>
                </span>
              </div>
            </div>

            <div class="col-sm-3">
              <div class="form-group required" aria-required="true">
                <label class="sub-header-drpdown">Transport mode</label>
                <ng-select
                  [clearable]="true"
                  [clearOnBackspace]="false"
                  #select
                  [items]="!truckChecked ? transportModeList : tempCustomTruck"
                  [searchable]="false"
                  formControlName="transportMode"
                  bindLabel="name"
                  (change)="changeTransportMode($event)"
                  [searchFn]="commonInputSearch"
                  placeholder="Transport mode *"
                >
                  <ng-template ng-header-tmp>
                    <div class="has-feedback">
                      <input
                        type="text"
                        class="form-control search-input"
                        id="inputValidation"
                        placeholder="Search..."
                        (input)="select.filter($any($event.target).value)"
                      />
                      <span class="form-control-feedback">
                        <i class="fa fa-search icon"></i>
                      </span>
                    </div>
                  </ng-template>
                  <ng-template ng-option-tmp let-item="item" let-search="searchTerm">
                    <div [ngOptionHighlight]="search" title="{{ item?.name }}">{{ item.name }}</div>
                  </ng-template>
                </ng-select>
              </div>
            </div>
            <div class="col-sm-3">
              <div class="form-group required" aria-required="true">
                <label class="sub-header-drpdown">Distance</label>
                <div class="services-form customTransportDistance">
                  <input
                    formControlName="distance"
                    (keydown)="noSpecialKeys($event)"
                    class="form-control input-custom-style"
                    placeholder="Distance"
                  />
                </div>
              </div>
            </div>
          </div>
          <div class="row" *ngIf="transportScenarioList.length && !enableMultipleSites">
            <div class="col d-flex justify-content-end">
              <button class="modelBtn setOriginBtn" (click)="setDestination()">
                Add transport leg
              </button>
            </div>
          </div>
          <div *ngIf="enableMultipleSites" class="row" style="padding: 0px 14px">
            <div class="panel panel-default">
              <div class="panel-heading"><span>Transportation to converter </span></div>
              <div class="panel-body">
                <ng-container
                  *ngrxLet="customFacade.multipleTransportErrorMsg$ as transportErrorMsg"
                >
                  <div class="input-error">
                    <ul>
                      <!-- <li *ngIf="(setOriginsubmitted && !this.customTransportScenarioForm.controls['origin'].value.idStr) ||
                                                    (setDestinationsubmitted && !this.customTransportScenarioForm.controls['destination'].value.idStr) ">
                                                Please select city from list
                                            </li> -->
                      <li
                        *ngIf="
                          (setDestinationsubmitted || addManualDistance) &&
                          !this.customTransportScenarioForm.controls['transportMode'].value
                        "
                      >
                        Please select transport mode
                      </li>
                      <li
                        *ngIf="(addManualDistance && !this.customTransportScenarioForm.controls['siteName'].value)||((setOriginsubmitted || setDestinationsubmitted) && customTransportScenarioForm.controls['siteName'].errors?.['required'])"
                      >
                        Please enter transport-site name
                      </li>
                      <li
                        *ngIf="
                          (setOriginsubmitted || addManualDistance || setDestinationsubmitted) &&
                          !doesExceed &&
                          (customTransportScenarioForm.controls['product'].errors ||
                            customTransportScenarioForm.controls['product'].value <= 0 ||
                            customTransportScenarioForm.controls['product'].value == null) &&
                          !(customTransportScenarioForm.controls['product'].value > 0)
                        "
                      >
                        Please enter product percentage
                      </li>
                      <li
                        *ngIf="customTransportScenarioForm.controls['distance'].errors?.['required'] && (setDestinationsubmitted || isAddManualDistanceData || addManualDistance) && customTransportScenarioForm.controls['distance'].value !== 0 "
                      >
                        Please enter distance
                      </li>
                      <li
                        *ngIf="
                          (setDestinationsubmitted || isManualDistances || addManualDistance) &&
                          customTransportScenarioForm.controls['distance'].value === 0
                        "
                      >
                        Must enter distance greater than 0
                      </li>
                      <li *ngIf="transportErrorMsg">
                        {{ transportErrorMsg }}
                      </li>
                      <li *ngIf="doesExceed">Percentage of product must not exceed 100%</li>
                      <li
                        *ngIf="
                          setDestinationsubmitted &&
                          customTransportScenarioForm.controls['destination'].errors
                        "
                      >
                        <div
                          *ngIf="customTransportScenarioForm.controls['destination'].errors?.['required']"
                          class="input-error"
                        >
                          Destination is required.
                        </div>
                      </li>
                      <!-- <li *ngIf="this.customTransportScenarioForm.controls['product'].value > 100 &&  customTransportScenarioForm.controls['product'].errors">
                                                <div *ngIf="addInTransport && customTransportScenarioForm.controls['product'].errors?.['max']" class="input-error">
                                                        <li>Percentage of product must not exceed 100%</li>
                                                </div>
                                            </li> -->
                      <li
                        *ngIf="
                          this.customTransportScenarioForm.controls['product'].value > 100 &&
                          customTransportScenarioForm.controls['product'].errors
                        "
                      >
                        <div
                          *ngIf=" customTransportScenarioForm.controls['product'].errors?.['max']"
                          class="input-error"
                        >
                          Percentage of product must not exceed 100%
                        </div>
                      </li>
                      <li
                        *ngIf="
                          setOriginsubmitted &&
                          customTransportScenarioForm.controls['origin'].errors
                        "
                      >
                        <div
                          *ngIf="customTransportScenarioForm.controls['origin'].errors?.['required']"
                          class="input-error"
                        >
                          Origin is required.
                        </div>
                      </li>
                      <ng-container
                        *ngrxLet="customFacade.distanceErrorProjectCustom$ as distanceErrorProject"
                      >
                        <li *ngIf="distanceErrorProject != ''">
                          <div class="mt-3">
                            <span class="input-error-distance">{{ distanceErrorProject }}</span>
                          </div>
                        </li>
                      </ng-container>
                    </ul>
                  </div>
                </ng-container>
                <div class="row">
                  <div class="col-sm-6">
                    <label
                      *ngIf="customTransportScenarioForm.get('scenario')?.value"
                      class="sub-header-drpdown pb-2"
                      >Transport scenario</label
                    >
                    <ng-select
                      [clearable]="false"
                      [clearOnBackspace]="false"
                      id="transportationList"
                      #select
                      [items]="transportationList"
                      [searchable]="false"
                      formControlName="scenario"
                      class="custom-margin-transport"
                      bindLabel="name"
                      (change)="changeScenario($event)"
                    >
                    </ng-select>
                  </div>
                  <div
                    class="col-sm-6 align-self-center"
                    *ngIf="isManualDistances || showCustomTruck"
                  >
                    <div class="row">
                      <div class="col-sm-6 d-flex checkbox-text checkBoxAlienMent">
                        <input
                          [ngModelOptions]="{ standalone: true }"
                          [(ngModel)]="truckChecked"
                          type="checkbox"
                          class="chkOverview"
                          (change)="isTruckChecked($event)"
                        />
                        <span>Custom truck</span>
                      </div>
                      <div
                        *ngIf="truckChecked"
                        class="col-sm-6 d-flex justify-content-end align-items-end pr-0"
                      >
                        <a class="add-link" target="_blank" routerLink="custom/customTrucks"
                          ><span class="redirectLinkText">Add custom truck</span></a
                        >
                        <a
                          class="setLinkIconPosition"
                          target="_blank"
                          replaceUrl="true"
                          routerLink="custom/customTrucks"
                        >
                          <img
                            src="./assets/icons/redirect-icon.svg"
                            alt=""
                            width="17"
                            height="15"
                          />
                        </a>
                        <span class="setLinkIconPosition" (click)="refreshTruckList()"
                          ><img
                            src="./assets/icons/refresh-circle.svg"
                            alt=""
                            width="16"
                            height="15"
                        /></span>
                      </div>
                    </div>
                  </div>
                </div>
                <div class="row">
                  <div class="col-sm-6">
                    <div class="custom-margin-transport required">
                      <piqet-angular-common-input
                        formControlName="siteName"
                        [control]="customTransportScenarioForm.get('siteName')"
                        label="Site name"
                        placeholder="Site name"
                        [maxLength]="50"
                        [submitted]="addManualDistance"
                      >
                      </piqet-angular-common-input>
                    </div>
                  </div>
                  <div class="col-sm-6" *ngrxLet="customFacade.remainingValue$ as remainingValue">
                    <div class="custom-margin-transport required" aria-required="true">
                      <piqet-angular-common-input
                        inputType="number"
                        formControlName="product"
                        [control]="customTransportScenarioForm.get('product')"
                        label="Product(%)"
                        placeholder="Product(%)"
                        [maxLength]="5"
                        [maxValue]="100"
                        [enableRangeValidation]="true"
                        [preventNegative]="true"
                        [submitted]="addManualDistance"
                      >
                        >
                      </piqet-angular-common-input>
                    </div>
                  </div>
                </div>
                <div
                  class="row"
                  *ngIf="transportScenarioList.length && !isManualDistances && !checkIsOrginBtn"
                >
                  <div class="col-sm-6 d-flex">
                    <div class="withtootips col-sm-11">
                      <div class="form-group" aria-required="true">
                        <div class="d-flex justify-content-end align-items-end">
                          <p class="highlights">Select locations with "(Port)" for shipping</p>
                        </div>
                        <label class="placeholder-sub-header">Holder_text</label>
                        <div
                          class="ng-autocomplete-upper-class destination-close"
                          style="box-shadow: none !important"
                        >
                          <ng-autocomplete
                            #auto
                            [data]="selectedCities"
                            [searchKeyword]="keyword"
                            (inputChanged)="onChangeSearch($event)"
                            historyIdentifier="selectedCities"
                            (selected)="selectEvent($event)"
                            (inputCleared)="onClearSearch($event)"
                            [itemTemplate]="itemTemplate"
                            [notFoundTemplate]="notFoundTemplate"
                            formControlName="destination"
                            [isLoading]="isLoading"
                            placeholder="Destination *"
                            (scrolledToEnd)="onScroll()"
                            [(ngModel)]="keywordAuto"
                            (keydown)="onKeyDownEvent($event)"
                          >
                          </ng-autocomplete>

                          <ng-template #itemTemplate let-item>
                            <div class="item"><span [innerHTML]="item.name"></span> &nbsp;</div>
                          </ng-template>

                          <ng-template #notFoundTemplate let-notFound>
                            <div [innerHTML]="notFound"></div>
                          </ng-template>
                        </div>
                      </div>
                    </div>
                    <div
                      class="align-self-center automatictooltip"
                      [ngClass]="
                        customTransportScenarioForm.get('transportMode')?.value ? 'icon-top' : ''
                      "
                    >
                      <span
                        placement="auto"
                        tooltipClass="sku-tooltip"
                        ngbTooltip="Hint: For automatic calculation of sea distance the origin and destination should be the cities with (Port)"
                      >
                        <a class="info-icon">
                          <span>
                            <img src="./assets/icons/grey-question-icon.svg" width="16" height="16"
                          /></span>
                        </a>
                      </span>
                    </div>
                  </div>

                  <div class="col-sm-3 custom-holder-spacing">
                    <div class="form-group required" aria-required="true">
                      <label class="sub-header-drpdown">Transport mode</label>
                      <ng-select
                        [clearable]="true"
                        [clearOnBackspace]="false"
                        #select
                        [items]="!truckChecked ? transportModeList : tempCustomTruck"
                        [searchable]="false"
                        formControlName="transportMode"
                        bindLabel="name"
                        (change)="changeTransportMode($event)"
                        [searchFn]="commonInputSearch"
                        placeholder="Transport mode *"
                      >
                        <ng-template ng-header-tmp>
                          <div class="has-feedback">
                            <input
                              type="text"
                              id="inputValidation"
                              class="form-control accordion-search search-input"
                              (input)="select.filter($any($event.target).value)"
                              placeholder="Search..."
                            />
                            <span class="form-control-feedback">
                              <i class="fa fa-search icon"></i>
                            </span>
                          </div>
                        </ng-template>
                        <ng-template ng-option-tmp let-item="item" let-search="searchTerm">
                          <div [ngOptionHighlight]="search" title="{{ item?.name }}">
                            {{ item.name }}
                          </div>
                        </ng-template>
                      </ng-select>
                    </div>
                  </div>
                  <div class="col-sm-3 custom-holder-spacing">
                    <div class="form-group" aria-required="true">
                      <label class="sub-header-drpdown">Distance</label>
                      <div class="services-form customTransportDistance">
                        <input
                          formControlName="distance"
                          (keydown)="noSpecialKeys($event)"
                          class="form-control input-custom-style"
                          placeholder="Distance"
                        />
                      </div>
                    </div>
                  </div>
                </div>
                <div
                  class="row d-flex justify-content-end"
                  *ngIf="transportScenarioList.length && !isManualDistances && !checkIsOrginBtn"
                >
                  <div class="col-sm-3 buttonrights">
                    <button
                      class="modelBtn setOriginBtn"
                      *ngIf="!isCheckUpdateDestination"
                      (click)="setDestination()"
                    >
                      Add transport leg
                    </button>
                    <button
                      class="modelBtn setOriginBtn"
                      *ngIf="isCheckUpdateDestination"
                      (click)="setDestination()"
                    >
                      Update
                    </button>
                  </div>
                </div>
                <div *ngIf="isManualDistances && (truckChecked || !truckChecked)" class="row">
                  <div class="col-sm-6">
                    <div class="form-group required" aria-required="true">
                      <label
                        *ngIf="
                          isManualDistances &&
                          customTransportScenarioForm.get('transportMode')?.value
                        "
                        class="sub-header-drpdown pb-2"
                        >Transport mode</label
                      >
                      <ng-select
                        [clearable]="true"
                        [clearOnBackspace]="false"
                        #select
                        [items]="!truckChecked ? transportModeList : tempCustomTruck"
                        [searchable]="false"
                        formControlName="transportMode"
                        bindLabel="name"
                        (change)="changeTransportMode($event)"
                        [searchFn]="commonInputSearch"
                        placeholder="Transport mode *"
                      >
                        <ng-template ng-header-tmp>
                          <div class="has-feedback">
                            <input
                              type="text"
                              class="form-control search-input"
                              id="inputValidation"
                              (input)="select.filter($any($event.target).value)"
                              placeholder="Search..."
                            />
                            <span class="form-control-feedback">
                              <i class="fa fa-search icon"></i>
                            </span>
                          </div>
                        </ng-template>
                        <ng-template ng-option-tmp let-item="item" let-search="searchTerm">
                          <div [ngOptionHighlight]="search" title="{{ item?.name }}">
                            {{ item.name }}
                          </div>
                        </ng-template>
                      </ng-select>
                    </div>
                  </div>
                  <div class="col-sm-3">
                    <div class="form-group required" aria-required="true">
                      <label
                        *ngIf="
                          isManualDistances &&
                          customTransportScenarioForm.get('transportMode')?.value
                        "
                        class="placeholder-sub-header pb-2"
                        >Holder_text</label
                      >
                      <div class="services-form">
                        <input
                          formControlName="distance"
                          (keydown)="noSpecialKeys($event)"
                          class="form-control input-custom-style"
                          placeholder="Distance"
                        />
                        <label>Distance</label>
                      </div>
                    </div>
                  </div>
                  <div class="col-sm-3">
                    <label
                      *ngIf="
                        isManualDistances && customTransportScenarioForm.get('transportMode')?.value
                      "
                      class="placeholder-sub-header pb-2"
                      >Holder_text</label
                    >
                    <button
                      class="modelBtn"
                      *ngIf="!isCheckEditManudalDist"
                      (click)="addManualDistanceData()"
                    >
                      Add
                    </button>
                    <button
                      class="modelBtn setOriginBtn"
                      *ngIf="isCheckEditManudalDist"
                      (click)="addManualDistanceData()"
                    >
                      Update
                    </button>
                  </div>
                </div>

                <div
                  class="row"
                  *ngIf="(!isManualDistances && !transportScenarioList.length) || checkIsOrginBtn"
                >
                  <div class="col-6">
                    <div class="d-flex justify-content-end align-items-end">
                      <p class="highlights" placeholder="Origin">
                        Select locations with "(Port)" for shipping
                      </p>
                    </div>
                  </div>
                </div>

                <div
                  class="row"
                  *ngIf="(!isManualDistances && !transportScenarioList.length) || checkIsOrginBtn"
                >
                  <div class="col-sm-6">
                    <div class="form-group required" aria-required="true">
                      <div class="ng-autocomplete-upper-class">
                        <ng-autocomplete
                          #auto
                          [data]="selectedCities"
                          [searchKeyword]="keyword"
                          (inputChanged)="onChangeSearch($event)"
                          historyIdentifier="selectedCities"
                          (selected)="selectEvent($event)"
                          (inputCleared)="onClearSearch($event)"
                          [itemTemplate]="itemTemplate"
                          [notFoundTemplate]="notFoundTemplate"
                          formControlName="origin"
                          [isLoading]="isLoading"
                          placeholder="Origin *"
                          (scrolledToEnd)="onScroll()"
                          [(ngModel)]="keywordAuto"
                          (keydown)="onKeyDownEvent($event)"
                        >
                        </ng-autocomplete>

                        <ng-template #itemTemplate let-item>
                          <div class="item"><span [innerHTML]="item.name"></span> &nbsp;</div>
                        </ng-template>

                        <ng-template #notFoundTemplate let-notFound>
                          <div [innerHTML]="notFound"></div>
                        </ng-template>
                      </div>
                    </div>
                  </div>
                  <div class="col-sm-1 p-0 aligniconQuestion">
                    <span
                      placement="auto"
                      tooltipClass="sku-tooltip"
                      ngbTooltip="Hint: For automatic calculation of sea distance the origin and destination should be the cities with (Port)"
                    >
                      <a class="info-icon">
                        <span>
                          <img src="./assets/icons/grey-question-icon.svg" width="16" height="16"
                        /></span>
                      </a>
                    </span>
                  </div>
                </div>
                <div
                  class="row"
                  *ngIf="(!isManualDistances && !transportScenarioList.length) || checkIsOrginBtn"
                >
                  <div class="col-sm-12 buttonrights">
                    <button
                      class="modelBtn setOriginBtn"
                      *ngIf="!isCheckUpdateOrigin"
                      (click)="setOrigin()"
                    >
                      Set origin
                    </button>
                    <button
                      class="modelBtn setOriginBtn"
                      *ngIf="isCheckUpdateOrigin"
                      (click)="setOrigin()"
                    >
                      Update
                    </button>
                  </div>
                </div>
                <div class="row margin-top-10 grid-div" id="1">
                  <ng-container *ngIf="!hideOriginGrid && transportScenarioList.length">
                    <piqet-angular-portlet
                      [hidePagination]="true"
                      [hideSearch]="true"
                      [columnDefs]="columnDefs"
                      [frameworkComponents]="frameworkComponents"
                      [gridData]="transportScenarioList"
                      [gridName]="'Single Transport'"
                      [class]="'p-0 overflowCheck'"
                    >
                    </piqet-angular-portlet>
                  </ng-container>
                </div>
                <div class="row">
                  <div class="col-sm-3 mt-4">
                    <button
                      class="modelBtn"
                      (click)="
                        addInTransportScenario(transportScenarioList, multipleTransportScenarioList)
                      "
                    >
                      Add transport
                    </button>
                  </div>
                </div>
                <div class="row margin-top-10 grid-div" id="2">
                  <piqet-angular-portlet
                    [hidePagination]="true"
                    [hideSearch]="true"
                    [gridData]="multipleTransportScenarioList"
                    [columnDefs]="multipleTransportColDef"
                    [frameworkComponents]="frameworkComponents"
                    [gridName]="'Multiple Transport'"
                    [class]="'p-0 overflowCheck'"
                  >
                  </piqet-angular-portlet>
                </div>
              </div>
            </div>
          </div>
          <div class="row margin-top-10 grid-div" *ngIf="!enableMultipleSites" id="3">
            <ng-container>
              <piqet-angular-portlet
                [hidePagination]="true"
                [hideSearch]="true"
                [gridData]="transportScenarioList"
                [columnDefs]="columnDefsSingle"
                [frameworkComponents]="frameworkComponents"
                [gridName]="'Single Transport'"
                [class]="'p-0 overflowCheck'"
              >
              </piqet-angular-portlet>
            </ng-container>
          </div>
        </form>
      </div>

      <div class="modal-footer cutomBtn-margintop">
        <button type="button" class="cancelBtn" (click)="onClose()">Cancel</button>
        <button
          type="button"
          class="modelBtn purpleBtnHoverEffect"
          *ngIf="checkEntireAccess"
          (click)="onSave(replicateTransportScenarioList, multipleTransportScenarioList)"
        >
          Save
        </button>
      </div>
    </ng-container>
  </ng-container>
</div>
